import {
  Box,
  FormControl,
  Image,
  Input,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import { Img } from "../../../../content/Content";

import "./Searching.component.css";

const Searching = () => {
  return (
    <VStack position={"relative"} py="25px" w="100%">
      {/* desktop-version */}
      <Stack w="100%" className="desktop-version">
        <Image
          src={Img.liveSearchBg}
          alt=""
          w="100%"
          height="100%"
          borderRadius="25px"
        />
        <Stack
          position="absolute"
          top="0"
          left="0"
          right="0"
          bottom="0"
          flexDirection="row"
          alignItems="center"
          justifyContent={"flex-start"}
        >
          <Box
            w="50%"
            p="30px"
            display="flex"
            justifyContent="flex-start"
            flexDirection={"column"}
          >
            <Image
              src={Img.liveLogo}
              alt="liveLogo"
              w="133px"
              height="121px"
              borderRadius="25px"
            />
            <Text
              fontFamily="'Roboto', sans-serif"
              color="#fff"
              fontSize="20px"
              fontWeight="500"
            >
              SFX academy live channel to live
            </Text>
          </Box>
          <Box
            w="50%"
            p="30px"
            display="flex"
            alignItems="flex-end"
            flexDirection={"column"}
          >
            <Stack>
              <FormControl
                position={"relative"}
                display="inline-block"
                alignItems="center"
                margin="0 10px"
              >
                <Input
                  type="text"
                  bg="transparent"
                  border={"none"}
                  borderRadius="10px"
                  padding={"8px 40px"}
                  placeholder="Search educators"
                  fontFamily="'Roboto', sans-serif"
                  fontSize="20px"
                  fontWeight="500"
                  color="rgba(149, 151, 171, 1)"
                  _placeholder={{
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: "20px",
                    fontWeight: "500",
                    color: "rgba(149, 151, 171, 1)",
                  }}
                  backgroundColor="rgba(255, 255, 255, 1)"
                  _focus={{ outline: "0" }}
                />
                <Image
                  src={Img.search}
                  alt="search"
                  position={"absolute"}
                  right="14px"
                  top="14px"
                  cursor="pointer"
                  height="19px"
                  w="19px"
                />
              </FormControl>
            </Stack>
          </Box>
        </Stack>
      </Stack>
      {/* mobile-version */}
      <Stack w="100%" className="mobile-version">
        <Image
          src={Img.liveSearchBg}
          alt=""
          w="100%"
          height="236px"
          borderRadius="25px"
          objectFit={'cover'}
          objectPosition={'center'}
        />
        <Stack
          position="absolute"
          top="0"
          left="0"
          right="0"
          bottom="0"
          flexDirection="column"
          alignItems="center"
          justifyContent='center'
        >
          <Box
            w="100%"
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection={"column"}
          >
            <Image
              src={Img.liveLogo}
              alt="liveLogo"
              w="75px"
              height="68px"
            />
            <Text
              fontFamily="'Roboto', sans-serif"
              color="#fff"
              fontSize="20px"
              fontWeight="500"
            >
              SFX academy live channel to live
            </Text>
          </Box>
          <Box
            w="100%"
            pb="40px"
            display="flex"
            alignItems="center"
            flexDirection={"column"}
          >
            <Stack>
              <FormControl
                position={"relative"}
                display="inline-block"
                alignItems="center"
                margin="0 10px"
              >
                <Input
                  type="text"
                  bg="transparent"
                  border={"none"}
                  borderRadius="10px"
                  padding={"8px 40px"}
                  placeholder="Search educators"
                  fontFamily="'Roboto', sans-serif"
                  fontSize="20px"
                  fontWeight="500"
                  color="rgba(149, 151, 171, 1)"
                  _placeholder={{
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: "20px",
                    fontWeight: "500",
                    color: "rgba(149, 151, 171, 1)",
                  }}
                  backgroundColor="rgba(255, 255, 255, 1)"
                  _focus={{ outline: "0" }}
                />
                <Image
                  src={Img.search}
                  alt="search"
                  position={"absolute"}
                  right="14px"
                  top="14px"
                  cursor="pointer"
                  height="19px"
                  w="19px"
                />
              </FormControl>
            </Stack>
          </Box>
        </Stack>
      </Stack>
    </VStack>
  );
};

export default Searching;
